import { useSpring, animated } from "react-spring";

const NumberCounter = ({ n }) => {
  const { number } = useSpring({
    from: { number: 0 },
    number: n,
    delay: 200,
    config: { mass: 1, tension: 20, friction: 10 },
  });
  return <animated.span>{number.to((n) => n.toFixed(1))}</animated.span>;
};

export default NumberCounter;
